var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{staticClass:"inline-spinner",class:{ 'inline-spinner--center': _vm.center },attrs:{"w":_vm.size,"h":_vm.size,"icon":"loading"}})
}
var staticRenderFns = []

export { render, staticRenderFns }